(function() {
    angular.module('emarket.commons')
  .factory('Suggestion', ['$log', '$http', 'PATH', function($log, $http, PATH) {
      var storage = localStorage;
      var suggestionList;
      var key = 'suggestions';
      var getSuggestions = function() {
          var sugs = storage.getItem(key);
          if(sugs) {
              try {
                  sugs = JSON.parse(sugs);
              } catch(e) {
                  $log.error('Could\'n parse JSON', sugs);
              }
          }
          return sugs || [];
      };

      var updateSuggestions = function(sug) {
          suggestionList.push(sug);
          try {
              var sugs = JSON.stringify(suggestionList);
              storage.setItem(key, sugs);
          } catch(e) {
              $log.error('Could\' create suggestion list', suggestionList);
          }
      };
      var exists = function(sug) {
          return suggestionList.some(function(el) {
              return el.value === sug;
          });
      };

      var suggestion = {
          add: function(sug) {
              if(sug && !exists(sug)) {
                  updateSuggestions({value:sug, display:sug});
              }
          },
          getLatest: function() {

              if(!suggestionList) {
                  suggestionList = getSuggestions();
              }
              return suggestionList;
          },
          spellCheck: function(term) {
              return $http.get(PATH.api +'/suggestion?suggestion='+term)
            .then(function(response) {
                return response.data;
            });
          }
      };
      return suggestion;
  }]);
}());
